import di from "di";

import AllProductCollections from 'common/gql/query/store/products/AllProductCollections.gql'
import AllProductCategories from 'common/gql/query/store/products/AllProductCategories.gql'
import AllProducts from 'common/gql/query/store/products/AllProducts.gql'
import AllProductsSlim from 'common/gql/query/store/products/AllProductsSlim.gql'

import RealtimeSubject from '../enum/RealtimeSubject';
import RealtimeOperation from '../enum/RealtimeOperation';

export const ProductStoreAction = {
    POPULATE_PRODUCTS: 'POPULATE_PRODUCTS',
    LOAD_PRODUCT_COLLECTIONS: 'LOAD_PRODUCT_COLLECTIONS',
    LOAD_PRODUCT_CATEGORIES: 'LOAD_PRODUCT_CATEGORIES',
    LOAD_PRODUCTS: 'LOAD_PRODUCTS',
    EXECUTE_PRODUCTS_OPERATION: 'EXECUTE_PRODUCTS_OPERATION'
}

export const ProductStoreMutation = {
    SET_PRODUCT_COLLECTIONS: 'SET_PRODUCT_COLLECTIONS',
    SET_PRODUCT_CATEGORIES: 'SET_PRODUCT_CATEGORIES',
    SET_PRODUCTS: 'SET_PRODUCTS'
}

function createEmptyState() {

    return {

        collections: null,
        categories: null,
        products: null
    };
}

export const productsStore = {

    state(){

        return createEmptyState();
    },

    getters: {

        getProductCollection: state => id => {
            return state.collections?.find(collection => collection.id == id);
        },

        getProductCategory: state => id => {
            return state.categories?.find(category => category.id == id);
        },

        getProduct: state => id => {
            return state.products?.find(product => product.id == id);
        }
    },

    mutations: {

        clear(state) {
            Object.assign(state, createEmptyState());
        },

        [ProductStoreMutation.SET_PRODUCT_COLLECTIONS] (state, collections){
            state.collections = collections;
        },

        [ProductStoreMutation.SET_PRODUCT_CATEGORIES] (state, collections){
            state.categories = collections;
        },

        [ProductStoreMutation.SET_PRODUCTS] (state, collections){
            state.products = collections;
        }
    },

    actions: {

        async [ProductStoreAction.POPULATE_PRODUCTS] (ctx, options){

            return Promise.all([
                ctx.dispatch(ProductStoreAction.LOAD_PRODUCT_COLLECTIONS, options),
                ctx.dispatch(ProductStoreAction.LOAD_PRODUCT_CATEGORIES, options),
                ctx.dispatch(ProductStoreAction.LOAD_PRODUCTS, options)
            ])
        },

        async [ProductStoreAction.LOAD_PRODUCT_COLLECTIONS] (ctx, options){

            const apollo = di.get('apollo');

            const results = await apollo.query({
                query: AllProductCollections,
                fetchPolicy: options?.force ? 'network-only' : null
            });

            const collections = results.data?.allProductCollections?.items;
            ctx.commit(ProductStoreMutation.SET_PRODUCT_COLLECTIONS, collections);
        },

        async [ProductStoreAction.LOAD_PRODUCT_CATEGORIES] (ctx, options){

            const apollo = di.get('apollo');

            const results = await apollo.query({
                query: AllProductCategories,
                fetchPolicy: options?.force ? 'network-only' : null
            });

            const categories = results.data?.allProductCategories?.items;
            ctx.commit(ProductStoreMutation.SET_PRODUCT_CATEGORIES, categories);
        },

        async [ProductStoreAction.LOAD_PRODUCTS] (ctx, options){

            const apollo = di.get('apollo');

            const results = await apollo.query({
                query: options?.slim ? AllProductsSlim : AllProducts,
                fetchPolicy: options?.force ? 'network-only' : null
            });

            const products = results.data?.allProducts?.items;
            ctx.commit(ProductStoreMutation.SET_PRODUCTS, products);
        },

        async [ProductStoreAction.EXECUTE_PRODUCTS_OPERATION] (ctx, data){

            if(data.operation === RealtimeOperation.DELETE && data.subject !== RealtimeSubject.PRODUCT){
                return ctx.dispatch(ProductStoreAction.POPULATE_PRODUCTS, { force: true });
            }

            switch(data.subject){

                case RealtimeSubject.PRODUCT:
                    return ctx.dispatch(ProductStoreAction.LOAD_PRODUCTS, { force: true });

                case RealtimeSubject.PRODUCT_CATEGORY:
                    return ctx.dispatch(ProductStoreAction.LOAD_PRODUCT_CATEGORIES, { force: true });

                case RealtimeSubject.PRODUCT_COLLECTION:
                    return ctx.dispatch(ProductStoreAction.LOAD_PRODUCTS, { force: true });
            }
        }
    }
}